// modules
import React, {useEffect, useState} from "react";
import "../styles/Heatmap.scss";
import ApiService from "../services/ApiService.js";
import { useAuth } from "react-oidc-context";

const Heatmap = ({releaseId, isLoading}) => {

  const auth = useAuth();
  const [imageSrc, setImageSrc] = useState(null);
  const [error, setError] = useState(false);
  const [fetchingImage, setFetchingImage] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setImageSrc(null);
      setError(false);
      setFetchingImage(false);
      return;
    }

    const fetchImage = async () => {
      setError(false);
      setFetchingImage(true);
      const accessToken = auth.user?.access_token;
      try {
        const src = await ApiService.getHeatmapImageByReleaseId(releaseId, accessToken);
        setImageSrc(src);
      } catch (err) {
        console.error("Failed to load heatmap image:", err);
        setError(true);
      } finally {
        setFetchingImage(false);
      }
    }; 

    if (releaseId !== undefined) {
      fetchImage();
    }
    
  }, [auth.isAuthenticated, auth.user, releaseId, isLoading]);


  if (error) {
    return (
      <div className="hm-main-container">
        <div className="hm-error">Failed to load heatmap</div>
      </div>
    );
  }

  if (fetchingImage) {
    return (
      <div className="hm-main-container">
        <div className="hm-skeleton"></div>
      </div>
    );
  }

  if (!imageSrc) return null;

  return (
    <div className="hm-main-container">
      <img className="hm-img" src={imageSrc} alt="Heatmap" />
    </div>
  );
};

export default Heatmap;
